import { BusinessTravel, CountryTypesValues } from "../visatypes/country-types.enum";

const clDict = [];
const commonFields = ['firstName', 'middleName', 'lastName', 'nationality.id',
  'serviceLine.id', 'subServiceLine.id', 'globalRank.rankCode', 'globalGrade.gradeCode', 'requestor.id'];
clDict.push(
  {
    key: 'VisaPreApproval',
    country: 'SAU',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'BusinessVisa',
    country: 'SAU',
    criticalFields: ['embassy.id']
  },
  {
    key: 'ExitIqamatransfer',
    country: 'SAU',
    criticalFields: []
  },
  {
    key: 'Exitpermission',
    country: 'SAU',
    criticalFields: []
  },
  {
    key: 'GOSIadditional',
    country: 'SAU',
    criticalFields: ['onboardingType.id', 'specialExpat']
  },
  {
    key: 'GOSIremoval',
    country: 'SAU',
    criticalFields: ['specialExpat']
  },
  {
    key: 'IqamaIssuance',
    country: 'SAU',
    criticalFields: ['onboardingType.id']
  },
  {
    key: 'IqamaRenewal',
    country: 'SAU',
    criticalFields: ['onboardingType.id']
  },
  {
    key: 'PassportInfoUpdate',
    country: 'SAU',
    criticalFields: ['onboardingType.id']
  },
  {
    key: 'DocumentSupport',
    country: 'SAU',
    criticalFields: ['documentSupportType.id']
  },
  {
    key: 'VisaCancellation',
    country: 'SAU',
    criticalFields: []
  },

  {
    key: 'EmploymentVisa',
    country: 'SAU',
    criticalFields: ['immigrationCaseType.id','ptc.id','ewakalaAgent.id']
  },
  {
    key: 'IqamaTransfer',
    country: 'SAU',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'ARE-Tawteen',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id']
  },
  {
    key: 'ARE-BusinessVisitVisa',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id', 'entryType.id','durationOfStay.id']
  },
  {
    key: 'ARE-BusinessVisitVisaRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-BusinessVisitVisaCancellation',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-MissionVisa',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id']
  },
  {
    key: 'ARE-MissionVisaRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-RelativeWorkPermit',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id']
  },
  {
    key: 'ARE-TemporaryPTWorkPermit',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id','officeToBeVisited.id','officeLE.id']
  },
  {
    key: 'ARE-UaeGccNationalWorkPermit',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'officeToBeVisited.id', 'nationality.id','nationalityType.id','globalRank.rankCode','officeLE.id']
  },
  {
    key: 'ARE-GccUaeNationalWorkPermitRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id','nationalityType.id','globalRank.rankCode','officeLE.id','officeToBeVisited.id']
  },
  {
    key: 'ARE-DepVisaGccMarriedToExpat',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id','globalRank.rankCode','serviceLine.id']
  },
  {
    key: 'ARE-TransferResidency',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id','officeLE.id','officeToBeVisited.id']
  },
  {
    key: 'ARE-ChangeOfNationality',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id','officeLE.id','globalRank.rankCode']
  },
  {
    key: 'ARE-ChangeOfProfession',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id','officeLE.id','globalRank.rankCode']
  },
  {
    key: 'ARE-CicpaCard',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-VisaCancellationInside',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id','officeLE.id','employeeCurrentLocationCountry.id','dependentsUnderSponsorship.id','dependentsVisaOnHold.id']
  },
  {
    key: 'ARE-VisaCancellationOutside',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id']
  },
  {
    key: 'ARE-EmploymentVisaIssuance',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'officeToBeVisited.id', 'nationality.id','globalRank.rankCode','officeLE.id','immigrationCaseType.id']
  },
  {
    key: 'ARE-EmploymentVisaRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id','globalRank.rankCode','officeLE.id']
  },
  {
    key: 'ARE-DependentsVisaIssuance',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id', 'officeToBeVisited.id','serviceLine.id','globalRank.rankCode']
  },
  {
    key: 'ARE-DependentsVisaRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id','serviceLine.id','globalRank.rankCode']
  },
  {
    key: 'ARE-DependentsVisaCancellation',
    country: CountryTypesValues.UAE,
    criticalFields: ['nationality.id']
  },
  {
    key: 'ARE-PensionAddition',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-PensionRemoval',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-LabourCardCancellation',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id','labourCardCancellationType.id']
  },
  {
    key: 'ARE-MissionVisaCancellation',
    country: CountryTypesValues.UAE,
    criticalFields: []
  },
  {
    key: 'OMN-WorkPermitPreAprroval',
    country: 'OMN',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'OMN-EmploymentVisa',
    country: 'OMN',
    criticalFields: ['immigrationCaseType.id', ' visaStatus.id'],
    mandatoryFieldsOnCompletion: ['workPermitPreApprovalDate'
      , 'visaIssuanceDate'
      , 'visaExpiryDate']
  },
  {
    key: 'OMN-ResidencyPermitTransfer',
    country: 'OMN',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'OMN-MOLContractIssuance',
    country: 'OMN',
    criticalFields: ['onboardingType.id', 'nationality.id']
  },
  {
    key: 'OMN-ResidencyPermitIssuance',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'OMN-ResidencyPermitRenewal',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'OMN-ResidencyPermitCancellation',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'BHR-EmploymentVisa',
    country: 'BHR',
    criticalFields: ['nationality.id', 'immigrationCaseType.id', 'visaStatus.id']
  },
  {
    key: 'BHR-VisaTransfer',
    country: 'BHR',
    criticalFields: ['nationality.id', 'immigrationCaseType.id']
  },
  {
    key: 'BHR-GOSIRegistration',
    country: 'BHR',
    criticalFields: ['nationality.id']
  },
  {
    key: 'BHR-ResidencyPermitAndCPRIssuance',
    country: 'BHR',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'BHR-ResidencyPermitRenewal',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-ResidencyPermitCancellation',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-DependentsResidencyIssuance',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'OMN-MOLContractCancellation',
    country: 'OMN',
    criticalFields: ['nationality.id']
  },
  {
    key: 'OMN-DocumentAttestation',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'OMN-ShortTermVisa',
    country: 'OMN',
    criticalFields: ['shortTermVisa.id']
  },
  {
    key: 'BHR-GOSITermination',
    country: 'BHR',
    criticalFields: ['nationality.id']
  },
  {
    key: 'OMN-LetterRequest',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'OMN-ShortTermVisaExtension',
    country: 'OMN',
    criticalFields: []
  },

  {
    key: 'OMN-DependentsVisa',
    country: 'OMN',
    criticalFields: ['typeOfRequest.id']
  },

  {
    key: 'OMN-TransferOfResidencyPermitToNewPassport',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'OMN-ChangeOfProfession',
    country: 'OMN',
    criticalFields: []
  },
  {
    key: 'BHR-CPRSupport',
    country: 'BHR',
    criticalFields: ['cprCaseType.id']
  },
  {
    key: 'BHR-ChangeOfProfession',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-ShortTermVisa',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-TransferOfResidencyPermitToNewPassport',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-KSABusinessVisaSupport',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-ExitEmploymentVisaTransfer',
    country: 'BHR',
    criticalFields: []
  }
  ,
  {
    key: 'BHR-LetterRequest',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'BHR-ShortTermVisaExtension',
    country: 'BHR',
    criticalFields: []
  },
  {
    key: 'QAT-ChangeOfProfession',
    country: 'QAT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'QAT-DocumentAttestation',
    country: 'QAT',
    criticalFields: []
  },
  {
    key: 'QAT-ResidencyPermitIssuance',
    country: 'QTR',
    criticalFields: ['immigrationCaseType.id', 'officeLE.id']
  },
  {
    key: 'QAT-ResidencyPermitRenewal',
    country: 'QTR',
    criticalFields: ['immigrationCaseType.id', 'officeLE.id']
  },
  {
    key: 'QAT-BusinessVisa',
    country: 'QAT',
    criticalFields: ['immigrationCaseType.id', 'officeLE.id']
  },
  {
    key: 'QAT-ExitPermission',
    country: 'QAT',
    criticalFields: []
  },
  {
    key: 'QAT-LetterRequest',
    country: 'QAT',
    criticalFields: ['typeOfDocRequested']
  },
  {
    key: 'QAT-ExitResidencyPermitTransfer',
    country: 'QTR',
    criticalFields: ['officeLE.id', 'nationality.id']
  },
  {
    key: 'QAT-BusinessVisaExtension',
    country: 'QAT',
    criticalFields: []
  },
  {
    key: 'QAT-TransferOfResidencyPermitToNewPassport',
    country: 'QAT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'QAT-VisaPreAprroval',
    country: 'QAT',
    criticalFields: ['immigrationCaseType.id', 'officeLE.id', 'nationality.id']
  },
  {
    key: 'QAT-ResidencyPermitTransfer',
    country: 'QAT',
    criticalFields: ['immigrationCaseType.id', 'officeLE.id']
  },

  {
    key: 'QAT-ChangeOfProfession',
    country: 'QAT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'OMN-ExitResidencyPermitTransfer',
    country: 'OMN',
    criticalFields: []
  },


  {
    key: 'QAT-WorkPermitRenewal',
    country: 'QAT',
    criticalFields: ['gender.id', 'immigrationCaseType.id', 'officeLE.id', 'nationality.id', 'visaStatus.id']
  },
  {
    key: 'QAT-WorkPermitIssuance',
    country: 'QAT',
    criticalFields: ['preboardingType.id', 'immigrationCaseType.id', 'officeLE.id', 'gender.id', 'preboardingType.id', 'hireType.id']
  },
  {
    key: 'QAT-GovernmentGatePass',
    country: 'QAT',
    criticalFields: []
  },
  {
    key: 'QAT-EmploymentVisa',
    country: 'QAT',
    criticalFields: ['immigrationCaseType.id', 'officeLE.id', 'nationality.id', 'visaStatus.id']
  },
  {
    key: 'QAT-ResidencyPermitCancellation',
    country: 'QAT',
    criticalFields: ['officeLE.id']
  }
  ,
  {
    key: 'QAT-WorkPermitCancellation',
    country: 'QAT',
    criticalFields: ['officeLE.id', 'nationality.id']
  },
  {
    key: 'KWT-ExitResidencyPermitTransfer',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-LetterRequest',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-DocumentAttestation',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-ResidencePermitIssuance',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-ResidencyRenewal',
    country: 'KWT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'KWT-ResidencyPermitCancellation',
    country: 'KWT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'KWT-WorkPermitIssuance',
    country: 'KWT',
    criticalFields: ['preboardingType.id', 'immigrationCaseType.id', 'nationality.id']
  },
  {
    key: 'KWT-CivilIDSupport',
    country: 'KWT',
    criticalFields: ['typeOfSupport.id']
  },
  {
    key: 'KWT-DataModification',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-WorkPermitCancellation',
    country: 'KWT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'KWT-VisaPreApproval',
    country: 'KWT',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'KWT-EmploymentVisa',
    country: 'KWT',
    criticalFields: ['immigrationCaseType.id', 'nationality.id']
  },
  {
    key: 'KWT-KSABusinessVIsaSupport',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-CommercialVisitVisa',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-WorkPermitRenewal',
    country: 'KWT',
    criticalFields: ['nationality.id']
  },
  {
    key: 'KWT-ResidencyTransfer',
    country: 'KWT',
    criticalFields: ['immigrationCaseType.id']
  },
  {
    key: 'KWT-TransferOfResidencyToNewPassport',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-ChangeOfProfession',
    country: 'KWT',
    criticalFields: []
  },
  {
    key: 'KWT-DependentsResidencyVisaSupport',
    country: 'KWT',
    criticalFields: ['typeOfSupport.id']
  },
  {
    key: 'ARE-GoldenVisa',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id']
  },
  {
    key: 'ARE-GoldenVisaRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['officeToBeVisited.id', 'nationality.id', 'globalRank.rankCode', 'officeLE.id']
 
  },
  {
    key: 'OMN-DependentsRP-Issuance',
    country: 'KWT',
    criticalFields: []
  },
 
  {
    key: 'ARE-RelativeWorkPermitRenewal',
    country: CountryTypesValues.UAE,
    criticalFields: ['globalRank.rankCode']
  },
  {
    key: 'OMN-DependentsRP-Renewal',
    country: CountryTypesValues.OMAN,
    criticalFields: []
  },
  {
    key: 'OMN-DependentsVisaRenewal',
    country: CountryTypesValues.OMAN,
    criticalFields: []
  },
  {
    key: 'KWT-CommercialVisitVisaExtension',
    country: CountryTypesValues.KWT,
    criticalFields: []
  },
  {
    key: 'EGY-EmploymentVisa',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-KSABusinessVisaSupport',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-SIRegistration',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-SIPrint',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-SICancellation',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-EmploymentVisaRenewal',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-DependentRPCancellation',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-EmploymentVisaCancellation',
    country: CountryTypesValues.EGY,
    criticalFields: [ ]
  },
  {
    key: 'EGY-DependentRPRenewal',
    country: CountryTypesValues.EGY,
    criticalFields: [ 'nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-DependentRPIssuance',
    country: CountryTypesValues.EGY,
    criticalFields: [ 'nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-NJDocumentValidation',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id']
  },
  {
    key: 'EGY-NationalIDFormStamping',
    country: CountryTypesValues.EGY,
    criticalFields: ['nationality.id','officeToBeVisited.id','scpMembership.id']
  },
  {
    key: 'PAK-BusinessVisa',
    country: CountryTypesValues.PAK,
    criticalFields: [ ]
  },

  {
    key: 'JOR-KSABusinessVisaSupport',
    country: CountryTypesValues.JOR,
    criticalFields: [ ]
  },

  {
    key: 'JOR-BusinessVisitVisa',
    country: CountryTypesValues.JOR,
    criticalFields: [ ]
  },

  {
    key: 'JOR-BusinessVisitVisaExtension',
    country: CountryTypesValues.JOR,
    criticalFields: [ ]
  },
  {
    key: 'ARE-LabourcardWorkPermitIssuance',
    country: CountryTypesValues.UAE,
    criticalFields: ['preboardingType.id', 'nationality.id']
  },
    {
    key: 'BT-VisaConsultation',
    country: BusinessTravel.Value,
    criticalFields: ['officeToBeVisited.id']
  },
  {
    key: 'BT-VisaValidation',
    country: BusinessTravel.Value,
    criticalFields: ['officeToBeVisited.id','requestedService.id']
  },
  {
    key: 'BT-VisaApplicationSupport',
    country: BusinessTravel.Value,
    criticalFields: ['officeToBeVisited.id','countryToBeVisited.id','recommendedVisaType.id']
  },
);

Object.freeze(clDict);

export { clDict };
